import {ref} from "vue";
import axios from 'axios';
import {useAuthStore, getSessionToken} from "@/stores/authStore";
import {useSubscriptionStore} from "@/stores/subscriptionStore";

export const unreadNotificationsCount = ref(0);
// Set your API base URL
const apiClient = () => {
    const token = getSessionToken();

    const headers = {
        accept: '*/*',
        'X-Requested-With': 'XMLHttpRequest',
        'X-Client-Source': 'web',
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    return axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        withCredentials: true,
        headers,
    });
}

export const send = (method, endpoint, data = null, config = {}) => {
    const authUser = JSON.parse(localStorage.getItem('auth'));
    const client = apiClient();
    let response = null;
    switch (method.toLowerCase()) {
        case 'get':
            response = client.get(endpoint, {params: data, ...config});
            break;
        case 'put':
        case 'patch':
        case 'post':
            response = client[method.toLowerCase()](endpoint, data, config);
            break;
        case 'delete':
            response = client.delete(endpoint, data);
            break;
        default:
            throw new Error(`Unsupported HTTP method: ${method}`);
    }
    return processResponse(authUser, response);
}

const processResponse = (authUser, response) => {
    return response.then((result) => {
        const signature = result.headers.get('X-Signature');
        const url = result.request.responseURL;
        const isAuthRoute = url.includes('login') || url.includes('switch-company');

        if (signature) {
            if (isAuthRoute) {
                // Store signature from login/switch-company response
                let auth = JSON.parse(localStorage.getItem('auth'));
                if (auth) {
                    auth.signature = signature;
                    localStorage.setItem('auth', JSON.stringify(auth));
                }
            } else if (authUser?.signature && authUser.signature !== signature) {
                // Identity changed server-side - force logout
                useAuthStore().logout();
            }
        }
        if (result.data.hasOwnProperty('unreadNotifications')) {
            unreadNotificationsCount.value = result.data.unreadNotifications;
        }
        if (result.data.hasOwnProperty('paymentStatus')) {
            try {
                useSubscriptionStore().updateFromPaymentStatus(result.data.paymentStatus);
            } catch (e) {}
        }
        if (result.status === 401 || result.response?.status === 401) {
            useAuthStore().logout();
        }
        // Return the resolved response, not the original pending promise.
        // Returning `response` works because Promises/A+ unwraps it to
        // the same value, but it's surprising to readers and the extra
        // microtask is pointless. Return `result` directly.
        return result;
    }).catch((error) => {
        if (error.status === 401 || error.response?.status === 401) {
            useAuthStore().logout();
        }
        throw error; // Important: re-throw so caller can catch too
    });
}
